import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App.tsx';
import AxiosInterceptor from './utils/AxiosInterceptor.js';
import { Provider } from 'react-redux';
import store from './store/store.js';
import * as Sentry from '@sentry/react';
import { config } from './config/config.ts';
import Hotjar from '@hotjar/browser';

if (config.hotjarSiteId && config.hotjarVersion) {
  Hotjar.init(config.hotjarSiteId, config.hotjarVersion);
}

if (config.sentryDsn) {
  Sentry.init({
    dsn: config.sentryDsn,
    sendDefaultPii: true,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    tracesSampleRate: 1.0,
    tracePropagationTargets: [config.frontendUrl],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

AxiosInterceptor.initialize();

createRoot(document.getElementById('root')!).render(
  <Provider store={store}>
    <App />
  </Provider>,
);
